<template>
  <el-dialog
      title="操作记录"
      :visible.sync="dialogFormRecord"
      width="800px"
      height="480px"
      :modal="true"
      :lock-scroll="true"
      :close-on-click-modal="false"
    >
      <div v-loading="isLoadRecordData">
        <!-- <el-empty
          description="订单无操作记录~"
        ></el-empty> -->
        <el-timeline>
          <el-timeline-item
            v-for="(record, index) in recordList"
            :key="index"
            :timestamp="CreateTimeFormat(record.createTime)"
            placement="top"
          >
            <el-descriptions
              :title="record.operateType"
              direction="horizontal"
              :column="1"
            >
              <el-descriptions-item label="操作人">
                {{ record.operator }}
              </el-descriptions-item>
              <el-descriptions-item label="备注">
                {{ record.remark }}
              </el-descriptions-item>
            </el-descriptions>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div slot="footer" style="margin-top: 10px">
        <el-button type="info" size="mini" @click="dialogFormRecord = false">
          取消
        </el-button>
      </div>
    </el-dialog>
</template>

<script>
import moment from "moment";
export default {
    name: 'Record',
    data() {
        return {
            dialogFormRecord: false,
            isLoadRecordData: false,
            recordList: [],
        }
    },
    methods: {
        open(row){
            this.isLoadRecordData = true
            // 获取操作记录
            this.axios({
                url:'/generalOperateRecord/list',
                method: 'POST',
                data: {
                    bizTable:'ed_settlement_order',
                    bizId: row.id,
                }
            }).then(res=>{
                if(res.data.code == 200){
                    this.recordList = res.data.data
                }
                this.isLoadRecordData = false
            }).finally(()=>{
                this.isLoadRecordData = false
            })
            this.dialogFormRecord = true
        },
        CreateTimeFormat: function (time) {
            if (time !== null && time !== undefined) {
                return moment(time).format("YYYY-MM-DD HH:mm:ss");
            }
        },
    }
}
</script>

<style>

</style>